export default "__VITE_ASSET__lYTgEy0g__"